import React, { useState, useEffect, useRef } from 'react';
import { postAPI } from '../../../app/api';
import { setStore, removeStore, store } from '../../../app/store';
import Header from '../../Universal/Header';
import Footer from '../../Universal/Footer';
import { Navigation, Autoplay } from 'swiper/modules';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import ExecutiveCommittee from './ExecutiveCommittee';
import SubCommittes from "./SubCommittes";
import NoticeSection from '../Home/NoticeSection';
import OurJourney from './OurJourney';
import AboutSectionsDisplay from './AboutSectionsDisplay';
import PopupDisplay from '../../../components/PopupDisplay'; // Import PopupDisplay component
import OurVision from './OurVision';
import OurMission from './OurMission';
import AdvisoreCouncil from './AdvisoreCouncil';

// Use public path for aboutBanner and arrawLeft
const aboutBanner = "/images/from-html/banner-01.png";
const arrawLeft = "/images/from-html/map-icon.svg";
const { REACT_APP_BRANDURL } = process.env;

// Add CSS for skeleton loader animation
const skeletonStyles = `
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
`;

if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = skeletonStyles;
  document.head.appendChild(style);
}

export default function About() {
  const swiperRef = useRef(null);
  const [FormData, setFormData] = useState({
    user_type: 'ALUMNI',
    username: '',
    password: ''
  });
  const store_data = JSON.parse(store());
  const [Loading, setLoading] = useState(false);
  const [LoginStatus, setLoginStatus] = useState(0);
  const [HeroData, setHeroData] = useState(null);
  const [HeroLoading, setHeroLoading] = useState(true);
  const [isAutoPlayPaused, setIsAutoPlayPaused] = useState(false);
  const swiperInstanceRef = useRef(null);

  // Fallback hero data for 'about' route
  const fallbackHeroData = {
    title: 'Together in Spirit and Friendship',
    description: 'From a small group of ex-students meeting in Salt Lake in 1986 to a thriving alumni community today, the B E College Ex-Students\' Club has grown on the values of camaraderie, respect, and shared pride in our alma mater.',
    image: "/images/from-html/banner-01.png",
    route: 'about'
  };

  // console.log(store_data);

  useEffect(() => {
    console.log(store_data)
    setLoginStatus(store_data?.is_login || 0)
  }, [store_data?.is_login || 0])

  // Fetch hero data for 'about' route
  useEffect(() => {
    fetchHeroData();
    console.log('Fetching hero data for about page');
    console.log('HeroData:', HeroData);

  }, []);

  const fetchHeroData = async () => {
    try {
      setHeroLoading(true);
      const response = await postAPI('hero-data/fetchData/about', {});

      console.log('API Response:', response);

      if (response?.status === 1 && response?.data) {
        console.log('Hero data fetched:', response.data);
        setHeroData(response.data);
      } else {
        console.warn('Failed to fetch hero data, using fallback');
        console.warn('Response status:', response?.status);
        setHeroData(fallbackHeroData);
      }
    } catch (error) {
      console.error('Error fetching hero data:', error);
      setHeroData(fallbackHeroData);
    } finally {
      setHeroLoading(false);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...FormData,
      [name]: value
    });
  }

  const handleLogin = async () => {
    try {
      // Validate form
      if (!FormData.username || !FormData.password) {
        setLoginStatus({ status: 0, msg: "Please enter username and password" });
        return;
      }

      setLoading(true);
      const response = await postAPI(`authentication/users/login`, FormData);

      console.log("Response : ", response?.data?.access_token)

      if (response?.status === 1) {
        setLoginStatus({ status: 1, msg: response?.msg });
        // Store access token and user data
        setStore({
          'is_login': response?.data?.is_login,
          'expiry': response?.data?.expiry,
          'access_token': response?.data?.access_token,
          'user_code': response?.data?.user_code,
          'user_type': response?.data?.user_type,
          'full_name': response?.data?.full_name,
          'email_id': response?.data?.email_id,
          'mobile_number': response?.data?.mobile_number,
        });

        // Reset form
        setFormData({
          username: '',
          password: ''
        });

        window.location.reload();
      } else {
        setLoginStatus({ status: 0, msg: response?.msg || "Login failed" });
      }
    } catch (e) {
      console.error('Login error:', e);
      setLoginStatus({ status: 0, msg: e.message || "An error occurred" });
    } finally {
      setLoading(false);
    }
  }

  const handleAutoPlayToggle = () => {
    if (swiperInstanceRef.current && swiperInstanceRef.current.autoplay) {
      if (isAutoPlayPaused) {
        swiperInstanceRef.current.autoplay.start();
      } else {
        swiperInstanceRef.current.autoplay.stop();
      }
      setIsAutoPlayPaused(!isAutoPlayPaused);
    }
  };


  useEffect(() => {
    if (swiperRef.current) {

      const sliderSwiper = new Swiper(swiperRef.current, {
        modules: [Navigation],

        spaceBetween: 30,
        slidesPerView: 3,
        loop: true,
        centeredSlides: false,
        speed: 3000,

        watchOverflow: false,


        freeMode: true,
        freeModeMomentum: false,
        allowTouchMove: true,

        breakpoints: {
          1500: { slidesPerView: 2 },
          1200: { slidesPerView: 3 },
          992: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          576: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        },

        navigation: {
          nextEl: ".service-next",
          prevEl: ".service-prev",
        },
      });


      swiperInstanceRef.current = sliderSwiper;

      return () => {
        if (sliderSwiper) sliderSwiper.destroy();
      };
    }
  }, []);



  const journeyData = [
    {
      year: "1986",
      date: "8-Jun-86",
      title: "Formal Inauguration of Club",
      description: "With increasing membership, a Managing Committee was formed. Shri Prasanta Kumar Pal became the first President, with Mrinal Kanti Mitra (General Secretary), Bani Dasgupta (Treasurer), and Biren Pal (Joint Secretary). The club was formally inaugurated with 134 members by Debes Mukherjee, an illustrious engineer and ex-student of BE College(Civil -35) ."
    },
    {
      year: "1986",
      date: "Jun-86",
      title: "First Get-Together",
      description: "The first get-together of the club was organized at the State Guest House, Bidhannagar."
    },
    {
      year: "1987",
      date: "16-Apr-87",
      title: "Club Registration, Early Activities & Funding",
      description: "The club was officially registered under registration number S/54923. Regular get-togethers and committee meetings were held at members’ homes. Expenses were met through quarterly subscriptions collected door-to-door by volunteers. Cultural activities were organized at BD Auditorium, Technical Teachers’ Training Institute Auditorium, and Bidyut Bhavan."
    },
    {
      year: "1990",
      date: "17-Nov-90",
      title: "Land Ownership Registered",
      description: "Ownership of land allotted by the Government was officially registered."
    },
    {
      year: "1991",
      date: "18-Jun-91",
      title: "Possession of Land",
      description: "Physical possession of the allotted land was taken by the club."
    },
    {
      year: "1992",
      date: "",
      title: "Temporary Structure Built",
      description: "A small temporary structure with wooden and glass walls and a light fabricated roof was constructed on the land."
    },
    {
      year: "1996",
      date: "",
      title: "Decision for Permanent Building",
      description: "The idea of constructing a permanent building was proposed. Shri Jyoti Roy was assigned to prepare the building plan."
    },
    {
      year: "1997",
      date: "11-Oct-97",
      title: "Foundation Stone Laid",
      description: "The foundation stone of the club building was laid by Dr. Sankar Sen."
    },
    {
      year: "1999",
      date: "Late 1999",
      title: "Start of Building Construction",
      description: "Construction of the permanent club building commenced, supported by member donations, seminar surplus funds, and donations from Dr. M. N. Dastur. Md. Rafique,a well known Architect, served as the architect in charge."
    },
    {
      year: "2000",
      date: "6-Aug-00",
      title: "Inauguration of Ground Floor",
      description: "The ground floor of the club building was inaugurated."
    },
    {
      year: "2002",
      date: "Late 2002",
      title: "Decision to Construct First Floor",
      description: "The Managing Committee decided to construct the first floor of the building."
    },
    {
      year: "2004",
      date: "Late 2004",
      title: "Completion of First Floor",
      description: "Construction of the first floor, entrusted to M/S Aich & Associates, was completed with generous donations from members."
    },
    {
      year: "2006",
      date: "",
      title: "Formation of Ladies Group “PRAYAS”",
      description: "The ladies’ group of the club, PRAYAS, was formally started."
    },
    {
      year: "2009",
      date: "Early 2009",
      title: "Construction of Second Floor",
      description: "Construction of the second floor began. Due to funding shortfall, financial support was sought from Development Consultants Ltd., Kolkata."
    },
    {
      year: "2010",
      date: "15-Apr-10",
      title: "Inauguration of Club Lounge & Lift Installation",
      description: "Mrs. Shanta Ghosh donated Rs. 15 lakh to create the club lounge in memory of her father. The lift, donated by M/S METCO, was installed and the lounge inaugurated by Mrs. Ghosh."
    },
    {
      year: "2011",
      date: "",
      title: "Silver Jubilee Celebration",
      description: "Silver Jubilee celebrated with a seminar on “Engineering Education and Training – Need of the Profession and Industry,” felicitation of luminary alumni Buddhadeb Dasgupta and Badal Sarkar, and a sarod recital by Shri Buddhadeb Dasgupta."
    },
    {
      year: "2026",
      date: "",
      title: "Celebrating 40 Years of Legacy, Unity, and Excellence",
      description: "The Club's 40th Year Celebration spans six exciting days, featuring Annual Sports, Members’ Nite, an industry-cademia Round Table, and a vibrant Foundation Day. The celebrations conclude with a Musical Evening and a special theatrical performance, bringing alumni and members together in a joyful tribute to legacy and togetherness."
    }
  ];

  // Helper function to construct full image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath) return "/images/from-html/banner-01.png";
    if (imagePath.startsWith('http')) return imagePath;

    const apiUrl = process.env.REACT_APP_APIURL || 'https://beapi.shikshaprime.com/';
    const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
    return `${apiUrl}${cleanPath}`;
  };

  return (
    <>
      <Header />
      <section
        className="hero-section abtcs"
        style={{
          // backgroundImage: HeroLoading 
          //   ? 'linear-gradient(to right, #e0e0e0, #e0e0e0)'
          //   : `url(${getImageUrl(HeroData?.image || HeroData?.backgroundImage || fallbackHeroData.image)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative'
        }}
      >
        {HeroLoading && (
          <div style={{
            position: 'absolute',
            inset: 0,
            backgroundColor: '#e0e0e0',
            animation: 'pulse 1.5s infinite',
            borderRadius: '4px'
          }} />
        )}

        <div className="hero-content jstct" style={{ position: 'relative', zIndex: 1, textAlign: 'center', color: 'white', padding: '20px' }}>
          {HeroLoading ? (
            <>
              <div style={{ height: '60px', backgroundColor: '#d0d0d0', marginBottom: '20px', animation: 'pulse 1.5s infinite', borderRadius: '4px', width: '80%', margin: '0 auto' }} />
              <div style={{ height: '80px', backgroundColor: '#d0d0d0', animation: 'pulse 1.5s infinite', borderRadius: '4px', width: '95%', margin: '0 auto' }} />
            </>
          ) : (
            <>
              <h1 className="fw-bold display-5" style={{ color: HeroData?.titleColor || '#ffffff' }}>
                {HeroData?.title || fallbackHeroData.title}
              </h1>
              <p
                className="mt-lg-3 mt-1 mb-0"
                style={{
                  color: HeroData?.descriptionColor || '#ffffff',
                  fontFamily: HeroData?.descriptionFont || 'Arial',
                  fontSize: HeroData?.descriptionSize || '18px'
                }}
              >
                {HeroData?.description || fallbackHeroData.description}
              </p>
            </>
          )}
        </div>
      </section>

      {/* Display admin-managed about sections */}
      {/* <AboutSectionsDisplay /> */}

      <section className="journey">
        <div className="container-fluid">
          <div className='row justify-content-center'>
            <div className='col-lg-7'>
              <div className="text-center heading mb-5">
                <h2 className="">Our Journey So Far</h2>
                <p className="">
                  The Office Bearers of the B E College Ex-Students’ Club are entrusted with
                  the responsibility of managing the club’s activities, upholding its values,
                  and guiding its growth.
                </p>


              </div>
            </div>
          </div>

          <div className="timeline position-relative journey_action swiper" ref={swiperRef}>
            <div className='swiper-wrapper'>
              {journeyData.length > 0 && journeyData?.map((item, index) => (
                <div className='swiper-slide' key={index}>
                  <div className="timeline-item mb-lg-5 mb-md-3 mb-0 d-flex align-items-start">
                    <div className='text-center d-flex align-items-center justify-content-center flex-column'>
                      <div className="text-start mb-0"><p className="fw-bold year-text">{item.year}</p></div>
                      <div className="timeline-circle"><span>{(index < 9) ? `0${index + 1}` : (index + 1)}</span></div>
                      <div className="timeline-line"></div>
                    </div>
                    <div className="timeline-content text-start">
                      {item.date && <span className="date-badge">{item.date}</span>}
                      <h5 className="">{item.title}</h5>
                      <p className="mt-lg-4 mt-2">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
              {/* <OurJourney /> */}
            </div>
          </div>
          <div className="mt-4 w-100 d-flex justify-content-center gap-3 align-items-center">
            <button className="service-prev btn btn-primary py-1 px-3">
              <i className="fa fa-angle-left"></i>
            </button>
           
            <button className="service-next btn btn-primary py-1 px-3">
              <i className="fa fa-angle-right"></i>
            </button>
          </div>
        </div>
      </section >
      {/* <OurMember /> */}
      <AdvisoreCouncil />
      <ExecutiveCommittee />
      <SubCommittes />
      <OurMission />
      <OurVision />
      {/* <NoticeSection /> */}
      <Footer />
      <PopupDisplay currentPage="about-us" /> {/* Add PopupDisplay component here for About Us page */}
    </>
  )
}
